/**
 * @flow
 * @format
 */

import _RightToolBar from './RightToolBar';

export default _RightToolBar;



// WEBPACK FOOTER //
// ./src/components/RightToolBar/index.js